const KAWAII_MOODS = ['sad', 'worried', 'happy', 'lovestruck'];
const KAWAII_TYPES = ['email', 'film', 'magnifier', 'popcorn', 'ticket'];

export {
  KAWAII_MOODS,
  KAWAII_TYPES,
}
